import { BuyBoxModals } from '@product/BuyBox/modals/BuyBoxModals';
import { wishListAddItem } from '@libs/catalog-service';
import { getLocale } from '@libs/constants';
import { EXTERNAL_LINKS } from '@libs/redirect.helper';
import type { ServiceApiRequestError } from '@libs/service-api-request';
import { StatusCodes } from 'http-status-codes';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import type { SetStateAction } from 'react';
import { useMutation } from 'react-query';

export const useWishlist = (
  setActiveModal: (value: SetStateAction<BuyBoxModals | null>) => void,
  setAddToWishlistModalContent: (content: string) => void,
  openLogIn: (link: string) => boolean,
  sku: string
) => {
  const { t } = useTranslation('product/buyBox');
  const router = useRouter();
  const locale = getLocale(router);

  return useMutation((articleNo: string) => wishListAddItem({ artNo: articleNo }), {
    onSuccess: () => {
      setActiveModal(BuyBoxModals.ADD_TO_MYIGUS_WISH_LIST);
      setAddToWishlistModalContent(t('BUY_BOX.ADD_TO_WISHLIST_SUCCESS'));
    },
    onError: (error: ServiceApiRequestError) => {
      if (error.statusCode === StatusCodes.UNAUTHORIZED) {
        // TODO: remove this login popup when the feature is fully implemented
        openLogIn(EXTERNAL_LINKS.ADD_TO_WISHLIST(sku, locale));
      } else {
        setActiveModal(BuyBoxModals.ADD_TO_MYIGUS_WISH_LIST);
        setAddToWishlistModalContent(
          t(
            error.statusCode === StatusCodes.CONFLICT
              ? 'BUY_BOX.ADD_TO_WISHLIST_DUPLICATE'
              : 'BUY_BOX.ADD_TO_WISHLIST_FAIL'
          )
        );
      }
    },
  });
};
